/**
 * Katalog: BGW- & UVV-Jahresunterweisung Salon
 * Dokument-ID: PEPAPERS-COMPLIANCE-UVV-BGW-01
 */

export const UVV_DOC_ID = 'PEPAPERS-COMPLIANCE-UVV-BGW-01';

export const UVV_DOC_TITLE =
  'J\u00C4HRLICHE SICHERHEITSUNTERWEISUNG & UNFALLVERH\u00DCTUNG (BGW / UVV / DGUV V1)';

export const UVV_DOC_SUBTITLE =
  'Dokumentation gem\u00E4\u00DF \u00A7 12 Arbeitsschutzgesetz (ArbSchG) & DGUV Vorschrift 1';

export const UVV_INTERVAL_HINT =
  'J\u00E4hrlich gem. \u00A7 12 ArbSchG; f\u00FCr Jugendliche/Azubis U18 halbj\u00E4hrlich gem. \u00A7 29 JArbSchG (zwingend wiederholen!).';

export const UVV_LEITFADEN_HINT =
  'Prüf-/Besprechungsliste: Module Punkt für Punkt mit dem Team abarbeiten und abhaken.';

export type UvvUnterweisungsTurnus = 'jahresunterweisung' | 'halbjahres_u18';

export const UVV_DEFAULT_VERBANDKASTEN = 'Mixecke';
export const UVV_DEFAULT_VERBANDBLOCK = 'Büro / verschlossener Schrank';
export const UVV_DEFAULT_FEUERLOESCHER = 'Eingang / Notausgang';

export const UVV_CONFIRMATION_TEXT =
  'Hiermit bestätige ich, dass ich die oben aufgeführten Sicherheits-, Hygiene- und Unfallverhütungsvorschriften vollumfänglich verstanden habe und diese im Salonalltag strikt einhalte. Bei Unklarheiten oder Gefahrenstellen informiere ich umgehend die Salonleitung.';

export const UVV_INSTRUCTOR_SIGNATURE_LABEL =
  'Unterschrift Unterweisender (Saloninhaber / Meister): ___________________________';

export const UVV_SIGNATURE_ROW_COUNT = 10;

export type UvvBullet = string;

export interface UvvSection {
  title: string;
  bullets: UvvBullet[];
}

export interface UvvModule {
  id: string;
  number: number;
  title: string;
  legalRef?: string;
  sections: UvvSection[];
  locationPlaceholders?: Array<'verbandkasten' | 'verbandblock' | 'feuerloescher'>;
}

export const UVV_MODULES: UvvModule[] = [
  {
    id: 'hautschutz',
    number: 1,
    title: 'HAUTSCHUTZ & UMGANG MIT GEFAHRSTOFFEN (TRGS 530)',
    legalRef: 'TRGS 530',
    sections: [
      {
        title: '3-Phasen-Hautschutzplan (verbindliche Einhaltung)',
        bullets: [
          'Phase 1 (Vor Feuchtarbeit): Eincremen mit Hautschutzcreme (Gerbstoffe/Schutzfilm).',
          'Phase 2 (Während der Arbeit): Schonende Hautreinigung mit lauwarmem Wasser und pH-neutralen Syndets. Keine Bürsten zur Hautreinigung.',
          'Phase 3 (Nach der Arbeit / vor Pausen): Regenerierende Pflegecreme auftragen.',
        ],
      },
      {
        title: 'Handschuhpflicht (Nitril, ungepudert, mind. 30 cm Schaft)',
        bullets: [
          'Zwingend bei: Shampoonieren, Anmischen, Auftragen von Farbe/Tönung, Ausspülen von Chemie, Dauerwelle, Beckenreinigung.',
          'Einwegartikel: Nach einmaligem Gebrauch entsorgen, niemals umstülpen oder wiederverwenden.',
        ],
      },
      {
        title: 'Gefahrstoff-Handhabung',
        bullets: [
          'Blondierpulver: Staubfreies Arbeiten, vorsichtig einwiegen, nicht aufwirbeln (Inhalations- und Asthmagefahr).',
          'H2O2 / Entwickler: Flaschen aufrecht lagern und sofort verschließen.',
          'Umfüllverbot: Chemikalien niemals in lebensmittelähnliche oder unbeschriftete Behälter füllen.',
        ],
      },
    ],
  },
  {
    id: 'werkzeug',
    number: 2,
    title: 'WERKZEUG-SICHERHEIT, SCHNITT- & STICHVERLETZUNGEN (UVV)',
    legalRef: 'UVV / DSGVO',
    sections: [
      {
        title: 'Transport und Aufbewahrung',
        bullets: [
          'STRIKTES VERBOT: Scheren, Effilierscheren, Rasiermesser oder spitze Stielkämme lose in Hosen-, Kittel- oder Schürzentaschen zu stecken.',
          'Scheren nur geschlossen auf dem Rollboy ablegen oder im geschlossenen Holster tragen.',
          'Niemals mit offener Schere durch den Salon laufen.',
        ],
      },
      {
        title: 'Entsorgung von Klingen (Infektionsschutz)',
        bullets: [
          'STRIKTES VERBOT: Benutzte Klingen lose in den Hausmüll oder Papiereimer zu werfen.',
          'Klingen unmittelbar nach der Rasur in die stichfeste Kanülen-/Klingenabwurfbox (Hardcover) entsorgen.',
        ],
      },
      {
        title: 'Meldekette & DSGVO-konformer Meldeblock / Verbandblock',
        bullets: [
          'DSGVO-Pflicht: Ein offenes Verbandbuch ist datenschutzwidrig (Gesundheitsdaten gem. Art. 9 DSGVO für Dritte einsehbar).',
          'Vorgabe: Zwingende Nutzung eines DGUV-Meldeblocks (Abreißblock).',
          'Dokumentation: Nach Datum, Uhrzeit, Unfallhergang, Art der Verletzung, Ersthelfer sowie ANWESENDEN ZEUGEN Einzelblatt abtrennen und unter Verschluss in der Personalakte sichern (Aufbewahrung: 5 Jahre).',
          'Standort Verbandkasten: {{verbandkasten}}',
          'Standort Verbandblock / Meldeblock: {{verbandblock}}',
        ],
      },
    ],
    locationPlaceholders: ['verbandkasten', 'verbandblock'],
  },
  {
    id: 'stolpern',
    number: 3,
    title: 'STOLPER-, RUTSCH- & STURZFALLEN (DGUV V1)',
    legalRef: 'DGUV V1',
    sections: [
      {
        title: 'Beseitigung von Schnitthaaren (Föhn- & Chemie-Regel)',
        bullets: [
          'Sofortiges Fegen: Schnitthaare wirken wie Schmierseife. Bedienplatz SOFORT nach dem Schneiden fegen – BEVOR geföhnt wird und BEVOR Farbe/Chemie aufgetragen wird. Nicht erst bei der nächsten Kundin.',
        ],
      },
      {
        title: 'Nässe im Waschbereich',
        bullets: [
          'Verschüttetes Wasser oder Shampoo an Rückwärtswaschbecken sofort aufwischen.',
        ],
      },
      {
        title: 'Steighilfen',
        bullets: [
          'STRIKTES VERBOT: Bedienungsstühle, Drehhocker, Rollboys oder Klappkisten als Steighilfe zu benutzen. Nur geprüfte Sicherheits-Klapptritte oder Leitern.',
        ],
      },
      {
        title: 'Schuhwerk',
        bullets: [
          'Geschlossenes, trittsicheres Schuhwerk mit rutschfester Sohle und flachem Absatz ist Pflicht. Flip-Flops und Badeschlappen sind untersagt.',
        ],
      },
    ],
  },
  {
    id: 'elektro',
    number: 4,
    title: 'ELEKTROSICHERHEIT & BRANDSCHUTZ (DGUV V3)',
    legalRef: 'DGUV V3',
    sections: [
      {
        title: 'Bedienung elektrischer Geräte',
        bullets: [
          'STRIKTES ZUGVERBOT am Kabel: Stecker immer fest am Gehäuse umfassen. Kabel nicht knicken, quetschen oder über Laufwege legen.',
        ],
      },
      {
        title: 'Gerätedefekte & Sichtprüfung',
        bullets: [
          'Vor jeder Nutzung Sichtprüfung. Defekte Geräte sofort außer Betrieb nehmen, mit „DEFEKT - NICHT BENUTZEN“ kennzeichnen und melden.',
        ],
      },
      {
        title: 'Hitzegeräte & Feierabendkontrolle',
        bullets: [
          'Nur auf hitzebeständigen Silikon-/Metallunterlagen ablegen. Vor Verlassen: Alle Hitze- und Stylinggeräte vom Netz trennen.',
        ],
      },
      {
        title: 'Brandschutz',
        bullets: [
          'Flucht- und Rettungswege freihalten. Standort Feuerlöscher: {{feuerloescher}}',
        ],
      },
    ],
    locationPlaceholders: ['feuerloescher'],
  },
  {
    id: 'hygiene',
    number: 5,
    title: 'HYGIENE & DESINFEKTION (BIOSTOFFVERORDNUNG)',
    legalRef: 'BiostoffV',
    sections: [
      {
        title: 'Desinfektionsroutine von Werkzeugen',
        bullets: [
          'Scheren, Scherköpfe, Kämme und Bürsten nach jedem Kunden mechanisch reinigen und mit VAH-gelistetem Desinfektionsmittel behandeln (Einwirkzeit abwarten).',
        ],
      },
      {
        title: 'Rückwärtswaschbecken & Arbeitsflächen',
        bullets: [
          'Waschbecken und Nackenauflagen nach jeder Farbbehandlung sowie arbeitstäglich desinfizieren.',
        ],
      },
      {
        title: 'Einmalmaterialien',
        bullets: [
          'Halskrausen, Einwegtücher und Wattepads sofort im geschlossenen Restmüll entsorgen.',
        ],
      },
    ],
  },
];

/** Feste 2-Seiten-Packung für PDF (kein Schnitt mitten im Satz) */
export const UVV_MODULES_PAGE1 = UVV_MODULES.filter((m) => m.number <= 3);
export const UVV_MODULES_PAGE2 = UVV_MODULES.filter((m) => m.number >= 4);

export function formatUvvTurnusLine(turnus: UvvUnterweisungsTurnus): string {
  const jahres = turnus === 'jahresunterweisung' ? 'JA' : 'nein';
  const halb = turnus === 'halbjahres_u18' ? 'JA' : 'nein';
  return `Unterweisungs-Turnus: J\u00E4hrlich (\u00A7 12 ArbSchG): ${jahres} | Halbj\u00E4hrlich U18/Azubi (\u00A7 29 JArbSchG): ${halb}`;
}

export function resolveUvvBullet(
  text: string,
  locations: {
    verbandkasten: string;
    verbandblock: string;
    feuerloescher: string;
  }
): string {
  return text
    .replace(/\{\{verbandkasten\}\}/g, locations.verbandkasten || UVV_DEFAULT_VERBANDKASTEN)
    .replace(/\{\{verbandblock\}\}/g, locations.verbandblock || UVV_DEFAULT_VERBANDBLOCK)
    .replace(/\{\{feuerloescher\}\}/g, locations.feuerloescher || UVV_DEFAULT_FEUERLOESCHER);
}
